import config from "./_apiConfig/apiConfig";
import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const VEEFIN_DASHBOARD_URL = config.VEEFIN_DASHBOARD_URL;

export const getApplicationStatusRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.applicationStatus,
    data,
    true
  );
};

export const getApplicationStatusDetailsRequest = async ({ applicationId, ...data }) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.applicationStatusDetails(applicationId),
    data,
    true
  );
};
